export default '/src/assets/webgl/ui_audio/ui.mp3'